<template lang="pug">
  ul.nav.pull-right
    li.nav-item.inline.btn-mobile-block.selected-button(
    v-if="alternateMode"
    :class="{disabled: disabled}"
    )
      a.nav-link(@click="clearButtonClicked()")
        i.material-icons.md-18.m-r-sm &#xe5cd;
      span.selected-count {{ selectedCount }} selected

    li.nav-item.inline(
    v-for="a in actions"
    v-if="shouldShowAction(a)"
    :class="{dropdown: isGroupedAction(a)}"
    )
      a.btn.btn-fw.btn-mobile-block(
      v-if="!isGroupedAction(a)"
      :class="getActionStyle(a)"
      @click="a.action"
      ) {{ a.title }}

      a.btn.btn-fw.btn-mobile-block.dropdown-toggle(
      v-if="isGroupedAction(a)"
      data-toggle="dropdown"
      :class="getActionStyle(a)"
      ) {{ a.title }}

      .dropdown-menu.dropdown-menu-scale.pull-right
        a.dropdown-item(
        v-for="sa in a.action"
        :class="{disabled: isDisabledAction(sa)}"
        @click="callCallback(sa)"
        ) {{ sa.title }}
</template>

<script>
export default {
    props: {
        actions: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },

        alternateMode: {
            type: Boolean,
            required: false,
            default: false,
        },

        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },

        selectedCount: {
            type: Number,
            required: false,
            default: 1,
        },
    },

    methods: {
        callCallback(a) {
            if (this.isDisabledAction(a)) {
                return;
            }

            a.callback.call();
        },

        clearButtonClicked() {
            if (this.disabled) {
                return;
            }

            this.$emit('clear');
        },

        getActionStyle(a) {
            let clazz = {
                disabled: this.isDisabledAction(a),
                white: !this.alternateMode,
                'btn-outline': this.alternateMode,
                'b-white': this.alternateMode,
            };

            return _.merge(clazz, a.class);
        },

        isDisabledAction(a) {
            if (this.disabled) {
                return true;
            }

            let disabled = a.disabled;

            if (_.isBoolean(disabled)) {
                return disabled;
            }

            if (_.isFunction(disabled)) {
                return disabled.call();
            }

            return false;
        },

        isHiddenAction(a) {
            let hidden = a.hidden;

            if (_.isBoolean(hidden)) {
                return hidden;
            }

            if (_.isFunction(hidden)) {
                return hidden.call();
            }

            return false;
        },

        isGroupedAction(a) {
            return Array.isArray(a.action);
        },

        shouldShowAction(a) {
            let alternateAction = a.alternate || false;
            let hiddenAction = this.isHiddenAction(a);

            return this.alternateMode === alternateAction && !hiddenAction;
        },
    },
};
</script>

<style lang="scss" scoped>
.selected-button {
    margin-right: 0.5rem;
    text-align: left;
    vertical-align: middle;

    &.disabled {
        opacity: 0.65;
    }
}

.nav-item + .nav-item {
    margin-left: 0.5rem;
}

@media (max-width: 575px) {
    .nav-item {
        width: 100%;
    }

    .nav-item + .nav-item {
        margin-left: 0;
    }
}
</style>
